import { useEffect } from 'react';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import { TopTip } from '@/components/UI/svg/Wave2';

const bannerMsE1: any = {
    us: ['“', '”'],
    fr: ['«', '»'],
};

export default function A({ stage }: any) {
    const { t } = useLang('smartdevices');
    const { useRouter } = useGlobal();
    const { locale } = useRouter();

    useEffect(() => {
        // 动画--组件A
        AniContainer.create({
            syncFromTo: [['.smart-devices-treaser-A .smart-msga', { opacity: 1, ease: 'linear' }, { opacity: 0 }]],
            triggerElement: '.smart-devices-treaser-A',
            triggerHook: 0,
            offset: '-50%',
            duration: 300,
        });

        const offsetA = 100;
        const durationA = 300;
        // 动画--组件A--显示隐藏 1
        AniContainer.create({
            asyncFromTo: [
                ['.smart-devices-treaser-A .smart-msgb1 .smart-msgb-in', { opacity: 0, ease: 'linear' }, { opacity: 1 }, 0.2],
                ['.smart-devices-treaser-A .img-all', { opacity: 1, ease: 'linear' }, { opacity: 0 }, 0.2],
                ['.smart-devices-treaser-A .smart-msgb1 .smart-msgb-in', { opacity: 1, ease: 'linear' }, { opacity: 0 }, 0.2],
            ],
            asyncTimeLine: [0, 0, 0.6], // 动画触发事件线
            triggerElement: '.smart-devices-treaser-A .smart-msgb1',
            triggerHook: 1,
            offset: offsetA,
            duration: durationA,
        });

        // 动画--组件A--显示隐藏 2
        AniContainer.create({
            asyncFromTo: [
                ['.smart-devices-treaser-A .smart-msgb2 .smart-msgb-in', { opacity: 0, ease: 'linear' }, { opacity: 1 }, 0.2],
                ['.smart-devices-treaser-A .img-glacier', { opacity: 1, ease: 'linear' }, { opacity: 0 }, 0.2],
                ['.smart-devices-treaser-A .smart-msgb2 .smart-msgb-in', { opacity: 1, ease: 'linear' }, { opacity: 0 }, 0.2],
            ],
            asyncTimeLine: [0, 0, 0.6], // 动画触发事件线
            triggerElement: '.smart-devices-treaser-A .smart-msgb2',
            triggerHook: 1,
            offset: offsetA,
            duration: durationA,
        });

        // 动画--组件A--显示隐藏 3
        AniContainer.create({
            asyncFromTo: [
                ['.smart-devices-treaser-A .smart-msgb3 .smart-msgb-in', { opacity: 0, ease: 'linear' }, { opacity: 1 }, 0.2],
                ['.smart-devices-treaser-A .img-blade', { opacity: 1, ease: 'linear' }, { opacity: 0 }, 0.2],
                ['.smart-devices-treaser-A .smart-msgb3 .smart-msgb-in', { opacity: 1, ease: 'linear' }, { opacity: 0 }, 0.2],
            ],
            asyncTimeLine: [0, 0, 0.6], // 动画触发事件线
            triggerElement: '.smart-devices-treaser-A .smart-msgb3',
            triggerHook: 1,
            offset: offsetA,
            duration: durationA,
        });

        // 动画--组件A--显示隐藏 4
        AniContainer.create({
            asyncFromTo: [
                ['.smart-devices-treaser-A .smart-msgc .smart-msgc-in', { opacity: 0, ease: 'linear' }, { opacity: 1 }],
                ['.smart-devices-treaser-A .img-wave2', { opacity: 1, ease: 'linear' }, { opacity: 0 }],
            ],
            triggerElement: '.smart-devices-treaser-A .smart-msgc',
            triggerHook: 1,
            offset: offsetA,
            duration: durationA,
        });
    }, []);

    return (
        <div className={`smart-devices-treaser-A ${css.smartDevicesTreaserA}`}>
            <div className="smart-img-sticky">
                <div className="smart-img">
                    <div className="img-item img-all-2">
                        <NextImage
                            webpSrc={require('@publicLocal/smart-devices-teaser/h5/1.webp')}
                            src={require('@publicLocal/smart-devices-teaser/h5/1.jpg')}
                        />
                    </div>
                    <div className="img-item img-wave2">
                        <NextImage
                            webpSrc={require('@publicLocal/smart-devices-teaser/h5/1_wave2.webp')}
                            src={require('@publicLocal/smart-devices-teaser/h5/1_wave2.jpg')}
                        />
                    </div>
                    <div className="img-item img-blade">
                        <NextImage
                            webpSrc={require('@publicLocal/smart-devices-teaser/h5/1_blade.webp')}
                            src={require('@publicLocal/smart-devices-teaser/h5/1_blade.jpg')}
                        />
                    </div>
                    <div className="img-item img-glacier">
                        <NextImage
                            webpSrc={require('@publicLocal/smart-devices-teaser/h5/1_glacier.webp')}
                            src={require('@publicLocal/smart-devices-teaser/h5/1_glacier.jpg')}
                        />
                    </div>
                    <div className="img-item img-all">
                        <NextImage
                            webpSrc={require('@publicLocal/smart-devices-teaser/h5/1.webp')}
                            src={require('@publicLocal/smart-devices-teaser/h5/1.jpg')}
                        />
                    </div>
                </div>
            </div>
            {stage === 1 && (
                <div className="top-tip">
                    <TopTip />
                    <p className="text">{t('teaser.top_tip')}</p>
                </div>
            )}
            <div className="smart-msga">
                <div className="smart-logo">
                    <NextImage webpSrc={require('@publicLocal/ces_2023.webp')} src={require('@publicLocal/ces_2023.png')} />
                </div>
                {stage === 1 && <div className="smart-msga1">{t('teaser.bannerTitle')}</div>}
                <div className="smart-msga2">{t('teaser.bannerMs1')}</div>
                <div className="smart-msga3">{t('teaser.bannerMs2')}</div>
            </div>
            <div className="smart-msgb-box">
                <div className="smart-msgb smart-msgb1">
                    <div className="smart-msgb-in">
                        <div className="smart-msgb-ms1">{t('teaser.bannerMsB1')}</div>
                        <div className="smart-msgb-ms2">{t('teaser.bannerMsB2')}</div>
                    </div>
                </div>
                <div className="smart-msgb smart-msgb2">
                    <div className="smart-msgb-in">
                        <div className="smart-msgb-ms1">{t('teaser.bannerMsC1')}</div>
                        <div className="smart-msgb-ms2">{t('teaser.bannerMsC2')}</div>
                    </div>
                </div>
                <div className="smart-msgb smart-msgb3">
                    <div className="smart-msgb-in">
                        <div className="smart-msgb-ms1">{t('teaser.bannerMsD1')}</div>
                        <div className="smart-msgb-ms2">{t('teaser.bannerMsD2')}</div>
                    </div>
                </div>
                <div className="smart-msgc">
                    <div className="smart-msgc-in">
                        <div className="smart-msgc1">
                            <span className="smart-msgc-tip1">{bannerMsE1[locale] ? bannerMsE1[locale][0] : bannerMsE1.us[0]}</span>
                            <div>
                                {t('teaser.bannerMsE1')}
                                <span className="smart-msgc-tip2">{bannerMsE1[locale] ? bannerMsE1[locale][1] : bannerMsE1.us[1]}</span>
                            </div>
                        </div>
                        <div className="smart-msgc2">
                            {t.rich('teaser.bannerMsE2', {
                                name: (text: string) => <span className="underline">{text}</span>,
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
